import React from "react";
import {NameExceptionHandler} from "./NameException.js";
import Error from "../../FormElements/Error/Error.js"
/* "this" context refers to FormComponent instance */
export function ErrorInstanceHandler(o){
    if(o.type == Error){
        NameExceptionHandler(o.props.name);
        let errorState = `${o.props.name}_error`;
        o = React.cloneElement(o, {
            error : this.state["error"][errorState]?this.state["error"][errorState]:""
        })
    }
    return o;
}
